export const realtimeMeterData = [
  {
    id: "IOT-R001-GM",
    userId: "R001",
    userName: "张建国",
    address: "朝阳区建国路88号",
    deviceType: "燃气表",
    model: "G4-IC卡智能燃气表",
    currentReading: 1842.36,
    lastReading: 1813.86,
    usage: 28.5,
    pressure: 0.025,
    temperature: 20.5,
    battery: 85,
    signal: 92,
    status: "正常",
    lastUpdate: "2026-04-10 10:15:32",
    alarmStatus: null,
  },
  {
    id: "IOT-R002-GM",
    userId: "R002",
    userName: "李秀梅",
    address: "海淀区中关村南大街15号",
    deviceType: "燃气表",
    model: "G6-NB-IoT智能燃气表",
    currentReading: 3256.78,
    lastReading: 3221.58,
    usage: 35.2,
    pressure: 0.024,
    temperature: 19.8,
    battery: 62,
    signal: 78,
    status: "待校验",
    lastUpdate: "2026-04-10 10:12:18",
    alarmStatus: "校验到期",
  },
  {
    id: "IOT-C001-FM",
    userId: "C001",
    userName: "老北京涮肉馆",
    address: "东城区鼓楼东大街56号",
    deviceType: "流量计",
    model: "LWQ-50涡轮流量计",
    currentReading: 45623.56,
    lastReading: 44366.76,
    usage: 1256.8,
    pressure: 0.12,
    temperature: 20.0,
    battery: null,
    signal: 95,
    status: "正常",
    lastUpdate: "2026-04-10 10:16:05",
    alarmStatus: null,
  },
  {
    id: "IOT-C002-FM",
    userId: "C002",
    userName: "北京华联超市",
    address: "朝阳区朝阳路188号",
    deviceType: "流量计",
    model: "LWQ-200涡轮流量计",
    currentReading: 356821.45,
    lastReading: 348259.15,
    usage: 8562.3,
    pressure: 0.38,
    temperature: 18.2,
    battery: null,
    signal: 98,
    status: "正常",
    lastUpdate: "2026-04-10 10:16:22",
    alarmStatus: null,
  },
  {
    id: "IOT-R003-GM",
    userId: "R003",
    userName: "王大明",
    address: "西城区长安街100号",
    deviceType: "燃气表",
    model: "G10-NB-IoT智能燃气表",
    currentReading: 2156.42,
    lastReading: 2113.62,
    usage: 42.8,
    pressure: 0.026,
    temperature: 21.2,
    battery: 91,
    signal: 88,
    status: "正常",
    lastUpdate: "2026-04-10 10:14:55",
    alarmStatus: null,
  },
  {
    id: "IOT-C003-FM",
    userId: "C003",
    userName: "北京燃气热力工程设计院",
    address: "海淀区西三环北路甲2号",
    deviceType: "流量计",
    model: "LWQ-500超声波流量计",
    currentReading: 1256823.68,
    lastReading: 1231143.18,
    usage: 25680.5,
    pressure: 0.8,
    temperature: 22.0,
    battery: null,
    signal: 99,
    status: "正常",
    lastUpdate: "2026-04-10 10:16:45",
    alarmStatus: null,
  },
];

export const meterReadingHistory = [
  { date: "2026-04-10", reading: 1842.36, usage: 28.5, status: "正常" },
  { date: "2026-03-10", reading: 1813.86, usage: 31.2, status: "正常" },
  { date: "2026-02-10", reading: 1782.66, usage: 28.8, status: "正常" },
  { date: "2026-01-10", reading: 1753.86, usage: 32.1, status: "正常" },
  { date: "2025-12-10", reading: 1721.76, usage: 31.6, status: "正常" },
  { date: "2025-11-10", reading: 1690.16, usage: 29.8, status: "正常" },
  { date: "2025-10-10", reading: 1660.36, usage: 24.3, status: "正常" },
  { date: "2025-09-10", reading: 1636.06, usage: 19.5, status: "正常" },
  { date: "2025-08-10", reading: 1616.56, usage: 16.8, status: "正常" },
  { date: "2025-07-10", reading: 1599.76, usage: 17.2, status: "正常" },
  { date: "2025-06-10", reading: 1582.56, usage: 18.6, status: "正常" },
  { date: "2025-05-10", reading: 1563.96, usage: 20.1, status: "正常" },
];
